module.exports = __webpack_public_path__ + "img/bluetooth-disabled-button.015d39f1.svg";